module.exports = __webpack_public_path__ + "img/join-bg-mobile.d17a3304.svg";